import { ERC20Token } from "@icpswap/swap-sdk";

export const LINK = new ERC20Token({
  address: "0x514910771AF9Ca656af840dff83E8264EcF986CA",
  name: "LINK",
  symbol: "LINK",
  decimals: 18,
  logo: "/images/tokens/g4tto-rqaaa-aaaar-qageq-cai-erc20.png",
});
